import { makeStyles } from "@mui/styles";

export const GALLERY_CORNER_RADIUS = "8px";

const useGalleryStyle = makeStyles(() => ({
  menuAccordianWp: {
    "&:last-child": {
      marginBottom: "0",
    },
    "& .accordianWp": {
      "&.Platform-x-Accordion-root": {
        padding: 0,
        border: 0,
        borderRadius: 0,
        marginBottom: "0px",
        boxShadow: "none",
        "&.Mui-expanded:last-of-type": {
          marginBottom: "0px",
        },
        "& .accordianSummaryWp": {
          minHeight: "20px",
          "&.Platform-x-AccordionSummary-root": {
            padding: 0,
            background: "none",

            "& .Platform-x-AccordionSummary-content": {
              "& p": {
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              },
            },
          },
        },
        "& .Platform-x-AccordionSummary-expandIconWrapper.Mui-expanded": {
          transform: "rotate(90deg)",
          marginRight: "10px",
        },
        "& .Platform-x-AccordionSummary-expandIconWrapper": {
          marginRight: "10px",
        },
      },
    },
  },
  customBadge: {
    backgroundColor: "#14142b",
    color: "white",
  },
  menuitemListIcons: {
    "& img.contentIcon": {
      filter: "brightness(100) invert(1)",
    },
  },

  tagSearchField: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    boxSizing: "border-box",
    width: "100%",
    height: "36px",
    padding: "8px 10px",
    marginBottom: "12px",
    borderRadius: "5px",
    border: "1px solid #14142B",
    backgroundColor: "#ffffff",
    // InputBase ships its own vertical padding, which would break the 36px total.
    "& input": {
      padding: 0,
      height: "20px",
      fontSize: "14px",
      fontWeight: 400,
    },
  },
  filterChipsStack: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px",
    width: "100%",
  },
  filterChipsRow: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: "8px",
    width: "100%",
  },
  filterChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: "2px",
    paddingLeft: "10px",
    borderRadius: "16px",
    border: "1px solid #D9DBE9",
    backgroundColor: "#ffffff",
    maxWidth: "100%",
    "& .filterChipLabel": {
      color: "#14142B",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    // 24x24 minimum pointer target (WCAG 2.2 AA, 2.5.8) - the glyph inside is 14px.
    "& .filterChipRemove.Platform-x-IconButton-root": {
      width: "24px",
      height: "24px",
      color: "#57596C",
      "&:hover": {
        color: "#14142B",
      },
    },
  },
  filterChipApplied: {
    backgroundColor: "#D7ECFD",
    borderColor: "#D7ECFD",
    borderRadius: "5px",
  },
  filterChipsClearAll: {
    color: "#1E64ED",
    cursor: "pointer",
    padding: "4px",
  },
  sortByCard: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    padding: "14px 12px",
    borderRadius: GALLERY_CORNER_RADIUS,
    border: "1px solid #EFF0F6",
    backgroundColor: "#F7F7FC",
    color: "#14142B",
    cursor: "pointer",
    "&.selected": {
      backgroundColor: "#14142B",
      borderColor: "#14142B",
      color: "#ffffff",
      "& .sortByCardCaption": {
        color: "#D9DBE9",
      },
    },
    "& .sortByCardTitle": {
      display: "block",
    },
    "& .sortByCardCaption": {
      display: "block",
      color: "#57596C",
    },
    "&:focus-visible": {
      outline: "2px solid #1E64ED",
      outlineOffset: "2px",
    },
  },
  sortOptionGrid: {
    "&.Platform-x-FormGroup-root": {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "12px",
    },
    "& .Platform-x-FormControlLabel-root": {
      margin: "0px",
      padding: "10px 12px 10px 8px",
      borderRadius: GALLERY_CORNER_RADIUS,
      border: "1px solid transparent",
      backgroundColor: "#F7F7FC",
      "& .Platform-x-Radio-root": {
        color: "#B4B7C4",
      },
      "&:has(.Mui-checked)": {
        backgroundColor: "#ffffff",
        borderColor: "#14142B",
        "& .Platform-x-Radio-root": {
          color: "#14142B",
        },
      },
      "&.Mui-disabled": {
        "& .Platform-x-FormControlLabel-label": {
          color: "#B4B7C4",
        },
        "& .Platform-x-Radio-root": {
          color: "#DCDDE6",
        },
      },
      "&:focus-within": {
        outline: "2px solid #1E64ED",
        outlineOffset: "1px",
      },
    },
  },
  galleryListWrapper: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    padding: "0px 8px 8px 8px",
    "& .infinite-scroll-component__outerdiv": {
      width: "100%",
    },
    "& .infinite-scroll-component": {
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      overflow: "visible !important",
    },
  },
  galleryListRow: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    padding: "0px 20px",
    "@media (min-width: 1024px)": {
      paddingRight: "80px",
    },
    minHeight: "79px",
    backgroundColor: "#ffffff",
    borderRadius: "4px",
    border: "1px solid #EFEFEF",
    "&:hover": {
      backgroundColor: "#FAFAFC",
    },
    "&:focus-visible": {
      outline: "2px solid #1E64ED",
      outlineOffset: "2px",
    },
    "&.selected": {
      border: "1px solid #1E64ED",
      backgroundColor: "#F5F8FF",
    },
    "& .galleryListCheck": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "24px",
      height: "24px",
      flexShrink: 0,
    },
    "& .galleryListPipe": {
      display: "none",
      width: "1px",
      height: "45px",
      flexShrink: 0,
      backgroundColor: "#D9DBE9",
      "@media (min-width: 768px)": {
        display: "block",
      },
    },
    "& .galleryListPipe.typePipe": {
      marginLeft: "20px",
      marginRight: "12px",
    },
    "& .galleryListPipe.metaPipe": {
      display: "none",
      marginLeft: "12px",
      marginRight: "12px",
      "@media (min-width: 1024px)": {
        display: "block",
      },
    },
    "& .galleryListTypeIcon": {
      display: "none",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      borderRadius: "5px",
      overflow: "hidden",
      "& img": {
        width: "28px",
        height: "28px",
        objectFit: "contain",
      },
      "@media (min-width: 768px)": {
        display: "flex",
        width: "28px",
        height: "28px",
      },
    },
    "& .galleryListThumb": {
      width: "45px",
      height: "45px",
      borderRadius: "4px",
      overflow: "hidden",
      flexShrink: 0,
      "& img": {
        width: "100%",
        height: "100%",
        objectFit: "cover",
      },
    },
    "& .galleryListMain": {
      flex: 1,
      minWidth: 0,
      "@media (min-width: 1024px)": {
        maxWidth: "410px",
        marginRight: "auto",
      },
    },
    "& .galleryListTitle": {
      display: "block",
      color: "#14142B",
      wordBreak: "break-word",
    },
    "& .galleryListMetaText": {
      color: "#57596C",
      whiteSpace: "nowrap",
    },
    "& .galleryListMetaInline": {
      display: "flex",
      flexWrap: "wrap",
      gap: "8px",
      "@media (min-width: 1024px)": {
        display: "none",
      },
    },
    "& .galleryListMeta": {
      display: "none",
      "@media (min-width: 1024px)": {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        textAlign: "left",
        width: "160px",
        flexShrink: 0,
        "& .galleryListAuthor": {
          maxWidth: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
    },
    "& .galleryListOrderSlot": {
      width: "28px",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      flexShrink: 0,
    },
    "& .galleryListOrder.Platform-x-Chip-root": {
      width: "24px",
      height: "24px",
      borderRadius: "50%",
      flexShrink: 0,
      "& .Platform-x-Chip-label": {
        padding: 0,
        fontSize: "12px",
      },
    },
  },
}));

export default useGalleryStyle;
